import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

// Tell the backend the REAL public origin this app is served from. The backend uses it to
// build the public image URLs it hands to crun/Seedance, so clip generation works in every
// environment (preview AND production) regardless of internal cluster hostnames.
api.interceptors.request.use((config) => {
  try {
    config.headers["X-App-Origin"] = window.location.origin;
  } catch (e) {
    /* no-op */
  }
  return config;
});

export const mediaUrl = (id) => `${BACKEND_URL}/api/media/${id}`;

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
